carousel = {
    init(){
        $('#owl-carousel').owlCarousel({
            loop: true,
            dots: true,
            nav: true,
            margin: 20,
            onTranslated: callback,
            onInitialized: callback,
            responsiveClass: true,
            responsive:{
                0: {
                    items: 1,
                },
                1000: {
                    items: 3,
                },
                1921: {
                    items: 5,
                    center: true,
                }
            }
        });


        function callback(event) {
            $('.owl-item').removeClass('centered');
            $('.owl-item.center').prev().addClass('centered');
            $('.owl-item.center').next().addClass('centered');
            $('.owl-item.center').addClass('centered');
          }
    }
}

export let carousel;